import { Button, Card, CardContent, Typography } from "@mui/material";
import { CONNECTION_STATUS } from "pages/Admin/Whatsapp/WhatsappConnect";
import { toast } from "react-toastify";
import channelConnections from "services/admin/channelConnections";

interface TestSandboxConnectProps {
  channelConnection: any;
  refetch: () => void;
}

export const TestSandboxConnect = ({ channelConnection, refetch }: TestSandboxConnectProps) => {
  const handleConnect = async () => {
    console.log("Подключение к TestSandbox");
    try {
      const { data } = await channelConnections.connectTestSandbox(channelConnection.id);
      toast.success("TestSandbox подключен успешно!");
      console.log("data: ", data);
      refetch();
    } catch (error) {
      toast.error("Ошибка при подключении к TestSandbox: " + error);
      console.error(error);
    }
  };

  return (
    <div>
      <div>
        <div>
          <Typography variant="body1">
            ExternalAccountID: {channelConnection.externalAccountID}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            ExternalAccountUserName: {channelConnection.externalAccountUserName}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            ExternalAccountFirstName: {channelConnection.externalAccountFirstName}
          </Typography>
        </div>
      </div>
      <div className="mt-4">
        {channelConnection.connectionStatus != CONNECTION_STATUS.CONNECTED && (
          <Button variant="contained" color="primary" onClick={handleConnect}>
            Подключить
          </Button>
        )}
      </div>
    </div>
  );
};
